import React, { useState } from "react";
import MphLogo from "../../../assets/MphLogo.png";
import RecruiterLogo from "../../../assets/RecruiterLogo.png";
import { Login } from "../../../supports/login";
import { generateRequestId } from "../../../common/common";
import { useToast } from "../../../common/toastSystem";
import { useNavigate,useLocation } from "react-router-dom";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isForgotApiCalled, setIsForgotApiCalled] = useState(false);
  const [isvalidEmail, setisvalidEmail] = useState(true);
  const [errorMessage, setErrorMessage] = useState([]);
  const toast = useToast();
  const location = useLocation();
  const navigate = useNavigate();
  const isResumeLogin = location.pathname === "/resumeForgotPassword";
  const handleReset = async () => {
    setErrorMessage([]);
    setisvalidEmail(true);
    if (!isValidEmail(email)) {
      setisvalidEmail(false);
      return;
    }
    try {
      setIsForgotApiCalled(true);
      let errorMessage = [];
      let params = {
        email: email,
        is_recruiter: !isResumeLogin,
        user_payload: {
          request_id: generateRequestId(),
          email: email,
          tenant: "ABC",
        },
      };
      const response = await Login.forgotPassword(params);
      if (response.success) {
        setEmail("");
        toast.success(
          response.message || "Password reset link sent to your email"
        );
      } else {
        toast.warning(response.message || "Failed to send password reset link");
        errorMessage.push(
          response.message || "Failed to send password reset link"
        );
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.log("Error in forgot password:", error);
    } finally {
      setIsForgotApiCalled(false);
    }
  };

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let result = regex.test(email.trim());
    setisvalidEmail(result);
    return result;
  };

  return (
    <div className="min-h-screen main-background bg-white relative overflow-hidden">
      {/* Background decorative circles - matching second image style */}
      {/* <div className="absolute top-0 right-0 w-96 h-96 opacity-5">
        <div className="absolute top-20 right-20 w-80 h-80 rounded-full border-8 border-teal-700"></div>
        <div className="absolute top-40 right-40 w-60 h-60 rounded-full border-8 border-teal-700"></div>
      </div>
       */}
      {/* <div className="absolute bottom-0 left-0 w-96 h-96 opacity-5">
        <div className="absolute bottom-32 left-32 w-72 h-72 rounded-full border-8 border-teal-700"></div>
        <div className="absolute bottom-20 left-20 w-48 h-48 rounded-full border-8 border-teal-700"></div>
      </div> */}

      {/* Top colored bar */}
      <div className="w-full nav-bar-bg">
        <div className="flex justify-between items-center w-full px-8 py-4">
          {/* Logos */}
          <div className="flex items-center gap-4">
            <img src={MphLogo} alt="MPH Company Logo" className="h-12" />
            <img
              src={RecruiterLogo}
              alt="Recruiter Logo"
              className="w-16 mb-1"
            />
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex items-center justify-center py-4 h-[calc(100vh-80px)] px-4">
        <div className="w-full max-w-2xl">
          {/* Reset card */}
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-8">
            <h1 className="text-base font-semibold text-gray-700 mb-3">
              Reset your password
            </h1>

            {/* Yellow banner */}
            <div className="bg-yellow-100 border border-yellow-200 px-4 py-1.5 mb-4 rounded">
              <p className="text-sm text-gray-700">
                Enter the email address you used to register
              </p>
            </div>

            {/* Email field */}
            <div className="mb-4 relative">
              <label
                htmlFor="email"
                className="block text-sm font-semibold text-gray-700 mb-2"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => {
                  if (!isvalidEmail) {
                    setisvalidEmail(true);
                  }
                  setEmail(e.target.value);
                  if (errorMessage.length > 0) {
                    setErrorMessage([]);
                  }
                }}
                className="w-full text-sm px-3 py-1.5 border border-gray-300 rounded focus:border-transparent"
              />

              {/* Error message */}
              {!isvalidEmail && (
                <p className="absolute bottom-[-25px] text-xs text-red-600 mb-1">
                  Please enter a valid email address.
                </p>
              )}

              {errorMessage.length > 0 && (
                <p className="absolute bottom-[-25px] text-xs text-red-600 mb-1">
                  {errorMessage}
                </p>
              )}
            </div>

            {/* Reset button */}
            <div className="flex gap-2 justify-end">
              <button
                disabled={isForgotApiCalled}
                onClick={() => {
                  if(isResumeLogin){
                    navigate('/resume-login');
                }else{
                    navigate('/login');
                }
              }
             } className="border text-sm px-4 py-1.5 rounded transition-all duration-200"
              >
                Back
              </button>
              <button
                disabled={isForgotApiCalled}
                onClick={handleReset}
                className={`profiler-bg text-sm text-white px-4 py-1.5 rounded transition-all duration-200 ${
                  isForgotApiCalled || email.trim() === ""
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
